import { getResultCertificateNumbers } from '../state/selectors/getResultCertificateNumbers';
import { PageTypes, SummaryPageTypes } from '@shared/types';
export function prepareResults(results) {
    const icNumbers = getResultCertificateNumbers(results);
    let selectableType = PageTypes.certificate;
    const data = results.map(row => {
        if (row.type === SummaryPageTypes.summary_list) {
            selectableType = SummaryPageTypes.summary_list;
        }
        return Object.assign(Object.assign({}, row), { length: row.length !== null ? `${Number(row.length).toFixed(2)}` : null, certificateNumber: typeof row.icIndex === 'number' && row.certificateNumber === null && icNumbers[row.icIndex]
                ? icNumbers[row.icIndex]
                : row.certificateNumber });
    });
    return { data, selectableType };
}
